"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeasurePageLoad = exports.usePageMetrics = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var PageLoadProvider_1 = require("./PageLoadProvider");
/**
 * @param pageLoadConfig
 * @deprecated This hook has been deprecated in favour of useMeasurePageLoad and will no longer be available in the next release.
 */
var usePageMetrics = function (_a) {
    var pageIsLoading = _a.pageIsLoading, _b = _a.pageIsReloading, pageIsReloading = _b === void 0 ? function () { return false; } : _b, pageError = _a.pageError, _c = _a.data, data = _c === void 0 ? {} : _c;
    var _d = (0, PageLoadProvider_1.usePageLoadApi)(), url = _d.url, trackPageLoad = _d.trackPageLoad, initMetrics = _d.initMetrics, measurePageRefetch = _d.measurePageRefetch;
    var isLoading = (0, react_1.useRef)(null);
    var isReloading = (0, react_1.useRef)(null);
    isLoading.current = pageIsLoading;
    isReloading.current = pageIsReloading;
    var isPageLoading = isLoading.current();
    var isPageReloading = isReloading.current();
    var error = pageError ? pageError() : null;
    var loadedRef = (0, react_1.useRef)(false);
    var reloadRef = (0, react_1.useRef)(false);
    /**
     * Init metrics once page is mounted to guaranteed we always have
     * a metrics client initialized.
     */
    (0, react_1.useEffect)(function () {
        initMetrics(url);
    }, [initMetrics, url]);
    /**
     * Tracks a page load for both an initial page load and any subsequent page reload
     */
    var track = (0, react_1.useCallback)(function (pageUrl, pageErr, pageData) {
        if (pageData === void 0) { pageData = {}; }
        if (pageErr) {
            trackPageLoad(pageUrl, 'error', __assign(__assign({}, pageData), { type: 'handled_error', error_message: pageErr.message || pageErr.substr(0, 30) }));
        }
        else {
            trackPageLoad(pageUrl, 'success', __assign(__assign({}, pageData), { type: 'tracked' }));
        }
    }, [trackPageLoad]);
    /**
     * Effect to observe page loads and errors. Tracks a success page load or handled error once the page
     * is done loading. If a function to check if the page is reloading (isPageReloading) is provided, any
     * subsequent requests will be also tracked. Useful for pages that grab data from the cache initially
     * and then network and/or for pages that refetches for data with different variables (ex. AllSessions)
     */
    (0, react_1.useEffect)(function () {
        if (isPageLoading === false && !loadedRef.current) {
            track(url, error, data);
            loadedRef.current = true;
        }
        else if (loadedRef.current) {
            // We've already tracked the initial page load. Check if the page is refetching
            if (isPageReloading && !reloadRef.current) {
                // Measure event
                reloadRef.current = true;
                measurePageRefetch(url);
            }
            else if (reloadRef.current && !isPageReloading) {
                // Track page load
                track(url, error, data);
                reloadRef.current = false;
            }
        }
    }, [error, isPageLoading, isPageReloading, url, data, track, measurePageRefetch]);
};
exports.usePageMetrics = usePageMetrics;
/**
 * Component that allows pages to override metrics behaviour. A page using this component must
 * provide a loading and error callbacks (pageIsLoading, pageError) which are used to determine
 * if a page is loading content. Once the page indicates that it is not longer loading, this
 * component will track a page load including success page loads and errors as well as any
 * subsequent page load which is determined by the pageIsReloading callback provided by the consumer.
 *
 * An example of pages that could benefit from this behaviour are pages that execute the same query
 * but with different variables (UI allows user to refetch for a different set of data)
 *
 * @param {*} children
 * @param {*} pageIsLoading   Function used to check if a page is loading for content
 * @param {*} pageIsReloading Function used to check if a page is reloading content
 * @param {*} pageError       Function to check if a page encoutered an error
 * @param {*} data            Custom data a page can send to track a page load
 */
var PageMetrics = function (_a) {
    var children = _a.children, pageIsLoading = _a.pageIsLoading, _b = _a.pageIsReloading, pageIsReloading = _b === void 0 ? function () { return false; } : _b, pageError = _a.pageError, _c = _a.data, data = _c === void 0 ? {} : _c;
    (0, exports.usePageMetrics)({ pageIsLoading: pageIsLoading, pageIsReloading: pageIsReloading, pageError: pageError, data: data });
    // Provide metrics props to children component
    return React.cloneElement(children, {
        metricsOverriden: true
    });
};
// Export hook with a more accurate name
exports.useMeasurePageLoad = exports.usePageMetrics;
exports.default = PageMetrics;
